import { apiClient } from './client';
import { getContentActivityId, mapContentToGalleryImage } from './contents';

export async function fetchActivities() {
  const { data } = await apiClient.get('/activities');
  return data;
}

export async function createActivity({ name, description }) {
  const { data } = await apiClient.post('/activities', { name, description });
  return data;
}

export async function updateActivity(id, { name, description }) {
  const { data } = await apiClient.put(`/activities/${id}`, { name, description });
  return data;
}

export async function deleteActivity(id) {
  const { data } = await apiClient.delete(`/activities/${id}`);
  return data;
}

export function extractActivityFromResponse(data) {
  return data?.data ?? data;
}

export function extractActivitiesFromResponse(data) {
  const payload = data?.data ?? data;
  if (Array.isArray(payload)) {
    return payload;
  }
  if (Array.isArray(payload?.data)) {
    return payload.data;
  }
  return [];
}

export function mapActivityToTickerEvent(activity, contents = []) {
  const name = activity?.name || 'Activity';
  const activityId = activity?.id;

  const images = contents
    .filter((content) => String(getContentActivityId(content)) === String(activityId))
    .map((content) => mapContentToGalleryImage(content, name))
    .filter((image) => image.src);

  return {
    id: activity.id,
    title: name,
    images,
  };
}
